export const requestEnder = (store) => (next) => (action) => {
  if (action.type.slice(0, 6) === 'FETCH_') {
    store.dispatch({type: "FETCHING_DATA_STATE", state: false});
  }
  if (
    action.type.slice(0, 4) === 'ADD_' ||
    action.type.slice(0, 7) === 'CREATE_' ||
    action.type.slice(0, 5) === 'EDIT_'
  ) {
    store.dispatch({type: "SAVING_DATA_STATE", state: false});
  }
  next(action);
}



// WEBPACK FOOTER //
// ./src/middleware.js